import { reactive } from "vue";

/**
 * 上传大小限制（后台「上传设置」可配置，这里保存前端默认值，接口返回后覆盖）
 */
const DEFAULTS = {
  // 图片（封面/头像/轮播）上传上限，MB
  imageMaxMB: 10,
  // 工具附件 / 普通文件上传上限，MB
  fileMaxMB: 100,
  // ZIP 工具包解压后总大小上限，MB
  zipTotalMaxMB: 500,
  // 容器侧硬上限：后台配置不能超过它
  hardMaxMB: 110,
  // ZIP 解压总大小可配置的上限
  zipTotalUpperMB: 2000,
};

const config = reactive({ ...DEFAULTS });

export function setUploadConfig(data) {
  if (data) {
    Object.assign(config, data);
  }
}

export function getUploadConfig() {
  return config;
}

/** 图片上传上限（字节） */
export function imageMaxBytes() {
  return config.imageMaxMB * 1024 * 1024;
}

/** 附件上传上限（字节） */
export function fileMaxBytes() {
  return config.fileMaxMB * 1024 * 1024;
}

/**
 * 应用启动时加载一次上传限制（公开接口，失败则用默认值）
 */
export async function loadUploadConfig(axiosInstance) {
  try {
    const res = await axiosInstance({ url: "upload/config", method: "GET" });
    if (res && res.code === 200 && res.data) {
      setUploadConfig(res.data);
    }
  } catch (e) {
    /* 静默失败，使用默认值 */
  }
  return config;
}
